export default "__VITE_ASSET__CFSxXfnW__"